<template>
    <div v-if="registration">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row">

                <div class="d-none d-lg-block col-lg-4">

                    <user-card :user="learner"
                        :cohort="registration.cohort"
                        :groups="groups"
                        @openCohort="openCohort"
                        @openGroup="openGroup">
                    </user-card>

                </div>
                <div class="col-lg-8">
                    <registration :registration="registration"
                        :learner="learner"
                        :groups="groups"
                        :nav-to-overview="false"
                    ></registration>

                    <user-card class="d-lg-none"
                        :user="learner"
                        :cohort="registration.cohort"
                        :groups="groups"
                        :compact="true"
                        @openCohort="openCohort"
                        @openGroup="openGroup">
                    </user-card>

                    <tabs class="tabs"
                            tabNavClasses="nav-fill flex-column flex-sm-row nav-wrapper"
                            tabContentClasses="card shadow">

                        <tab-pane id="sessions">
                            <span slot="title">{{ $t('common.sessions') }}</span>
                            <simulations
                                :learner="learner"
                                :simulations="simulations"
                                :registration="registration"
                            ></simulations>
                        </tab-pane>

                        <tab-pane id="comments">
                            <span slot="title">{{ $t('dashboard.general-comments') }}</span>
                            <comments
                                :learner="learner"
                                :simulations="simulations"
                                :registration="registration"
                            ></comments>
                        </tab-pane>

                        <tab-pane id="grid1">
                            <span slot="title">
                                {{ $t('common.competencies') }}
                                <span v-if="registration.degree.simulation_role_2 && hasSecondGrid">
                                    : {{ registration.degree.simulation_role_1_name[registration.degree.lang] }}
                                </span>
                            </span>
                            <competencies
                                :simulations="simulations"
                                :competencies="competencies"
                                :position1-competencies="position1Competencies"
                                :position2-competencies="position2Competencies"
                                :registration="registration"
                                :rating-options="ratingOptions"
                                :num="1">
                            </competencies>
                        </tab-pane>

                        <tab-pane id="grid2" v-if="registration.degree.simulation_role_2 && hasSecondGrid">
                            <span slot="title">
                                {{ $t('common.competencies') }}:
                                {{ registration.degree.simulation_role_2_name[registration.degree.lang] }}
                            </span>
                            <competencies
                                :simulations="simulations"
                                :competencies="competencies"
                                :position1-competencies="position1Competencies"
                                :position2-competencies="position2Competencies"
                                :registration="registration"
                                :rating-options="ratingOptions"
                                :num="2">
                            </competencies>
                        </tab-pane>
                    </tabs>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UserCard from '../auth/components/UserCard'
    import Registration from './learner/Registration';
    import Simulations from './learner/Simulations';
    import Comments from './learner/GeneralComments';
    import Competencies from './learner/RegistrationCompetencies';

    export default {

        components: {
            UserCard, Registration, Simulations, Comments, Competencies
        },

        data() {
            return {
                learner: {},
                groups: null,
                registration: null,
                ratingOptions: null,
                simulations: null,
                domains: null,
                competencies: null,
                position1Competencies: null,
                position2Competencies: null,
            }
        },

        computed: {

            breadcrumb() {
                let breadcrumb = []
                if (this.$auth.user.id != this.$route.params.learnerId) {
                    breadcrumb.push({
                        name: this.learner.name,
                        route: '/astral/ui/dashboard/learners/' + this.$route.params.learnerId
                    })
                }
                breadcrumb.push({
                    name: this.registration.degree.name,
                })
                return breadcrumb
            },

            hasSecondGrid() {
                for (var index in this.simulations) {
                    if (this.simulations[index].grid2_id) {
                        return true
                    }
                }
                return false
            },
        },

        beforeRouteEnter(to, from, next) {
            Vue.prototype.$loader.show()
            axios.get('/astral/api/front/dashboard/registrations/'+to.params.registrationId+'/learners/'+to.params.learnerId)
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.data
                    vm.learner = resp.data.included.learner
                    vm.groups = resp.data.included.groups
                    vm.ratingOptions = resp.data.included.rating_options
                    vm.simulations = resp.data.included.simulations
                    vm.domains = resp.data.included.competency_domains
                    vm.competencies = resp.data.included.competencies
                    vm.position1Competencies = resp.data.included.position1_competencies
                    vm.position2Competencies = resp.data.included.position2_competencies
                    vm.$permissions.setRights(resp.data.included.rights)
                    vm.$loader.hide()
                })
            })
            .catch(err => {
                if (err.response.status == 403) {
                    next({ name: 'unauthorized' });
                }
            });
        },

        methods: {

            openCohort() {
                this.$router.push({
                    name: 'dashboard-cohort-registration',
                    params: {
                        cohortId: this.registration.cohort.id,
                        registrationId: this.registration.id,
                    }
                });
            },

            openGroup() {
                this.$router.push({
                    name: 'dashboard-group-registration',
                    params: {
                        groupId: this.groups[0].id,
                        registrationId: this.registration.id,
                    }
                });
            }
        }
    }
</script>

<style scoped>

    .tabs >>> .nav-pills {
        padding-top: 0;
        padding-bottom: 1.5rem;
    }

</style>
